export default __webpack_public_path__ + "static/media/Operator_img.b99360e9.jpg";